﻿import {CompteModel} from "./Compte/CompteModel.js";
import {RolesEnum} from "../Variables/RolesEnum.js";

export class ConnectedUser extends CompteModel {
    public DateExpiration: Date;

    constructor() {
        super();
    }

    public get IsValid(): boolean {
        if (this.DateExpiration == null)
            return false;

        return this.DateExpiration > new Date(new Date().getUTCDate());
    }

    public get IsSuperAdmin(): boolean {
        return this.Roles.find(x => x.Primarykey == RolesEnum.SuperAdmin) != null
    }
}
    